import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const HistoryTable = ({ settings, activeQuarter }) => {
  const theme = useTheme();
  const t     = theme.custom;

  // If a quarter is active show only its records, otherwise show all
  const rows = activeQuarter
    ? settings.filter((s) => s.quarter === activeQuarter)
    : settings;

  if (!rows?.length) return null;

  return (
    <Box sx={{ mt: "16px" }}>
      <Typography sx={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "9px", letterSpacing: "0.14em",
        textTransform: "uppercase", color: t.text3,
        borderTop: `1px solid ${t.border}`,
        paddingTop: "14px", mb: "8px",
      }}>
        {activeQuarter ? `History · ${activeQuarter}` : "History · All Quarters"}
      </Typography>

      {/* Header row */}
      <Box sx={{
        display: "grid",
        gridTemplateColumns: "80px 60px 1fr 100px",
        padding: "4px 8px", mb: "2px",
      }}>
        {["Quarter", "Cap", "Set By", "Date"].map((h) => (
          <Typography key={h} sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "8px", letterSpacing: "0.12em",
            textTransform: "uppercase", color: t.text3,
          }}>
            {h}
          </Typography>
        ))}
      </Box>

      {/* Data rows */}
      {rows.map((s) => (
        <Box
          key={s.poolId}
          sx={{
            display: "grid",
            gridTemplateColumns: "80px 60px 1fr 100px",
            padding: "7px 8px", borderRadius: "3px",
            transition: "background 0.12s",
            "&:hover": { background: t.surface2 },
          }}
        >
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "11px", color: t.accent,
          }}>
            {s.quarter}
          </Typography>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "11px", fontWeight: 600, color: t.text,
          }}>
            {s.ceiling}
          </Typography>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "11px", color: t.text2,
          }}>
            {s.setByName}
          </Typography>
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "10px", color: t.text3,
          }}>
            {new Date(s.setAt).toLocaleDateString("en-GB", {
              day: "2-digit", month: "short", year: "2-digit",
            })}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HistoryTable;